import { put, select, takeLatest } from 'redux-saga/effects';
import { GlobalActions } from '@ps20-frontend/shop-integration-redux';
import { App } from '@ps20-frontend/frontend-models';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { IAppState } from '../appState';
import { VwgActions } from '../vwgActions';
import { isFeuerrohbauSelectable } from '../../app/shared/selectors/gebaeude.selector';
import { GEBAEUDENUTZUNG_MERKMALE } from '../../app/shared/selectors/merkmale.selector';

export function* watchCorrectFeuerrohbau() {
  yield takeLatest(GlobalActions.SAVED_STATES_LOADED, safeSaga(correctFeuerrohbau, App.VWG_V2));
  yield takeLatest(GlobalActions.ADD_VORVERTRAG_TO_ANGEBOTE, safeSaga(correctFeuerrohbau, App.VWG_V2));
}

export function* correctFeuerrohbau() {
  const state: IAppState = yield select();

  if (state.buildingFeatures?.fireShellConstruction && !isFeuerrohbauSelectable(state)) {
    yield put(new VwgActions().merkmaleChanged({ name: 'fireShellConstruction', value: false }));

    const otherBuildingUsageSelected = GEBAEUDENUTZUNG_MERKMALE.filter(
      key => key !== 'fireShellConstruction',
    ).some(key => state.buildingFeatures[key]);

    if (!otherBuildingUsageSelected && !state.buildingFeatures.noneApplies) {
      yield put(new VwgActions().merkmaleChanged({ name: 'noneApplies', value: true }));
    }

    yield put(new VwgActions().preiseRequested());
  }
}
